<template>
    <main>
      <div class="container-fluid">
        <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="device-error-search-tab" data-bs-toggle="pill" data-bs-target="#device-error-search"
              type="button" role="tab" aria-controls="device-error-search" aria-selected="true"> 設備事件查詢 </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="device-error-statistic-tab" data-bs-toggle="pill" data-bs-target="#device-error-statistic" 
              type="button" role="tab" aria-controls="device-error-statistic" aria-selected="false">設備事件統計 </button>
          </li>
        </ul>
        <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
            <device-error-search></device-error-search>
            <device-error-statistic></device-error-statistic>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  import deviceErrorSearch from './deviceErrorSearch.vue';
  import deviceErrorStatistic from './deviceErrorStatistic.vue';
  
  
  
  
  export default {
    components: { deviceErrorSearch,deviceErrorStatistic},
    data() {
      return {
        
      };
    },
    computed: {
      
    },
    watch: {
      
    },
    methods: {
   
    },
    mounted() {
  
    },
  };
  </script>
  
  <style>
  </style>
  